import Vue from 'vue'
import Component from 'vue-class-component'
// @ts-ignore
import { IMessage } from '@/components/message.vue';

/**
 * A class for using Messages.
 *
 * Your message should be displayed like so (from details.vue):
 *
 * <Message v-if="message" :message="message.message" :type="message.type"
 *              :fade="message.fade"/>
 *
 */
@Component
export default class MessageMixin extends Vue {
  message: IMessage | null = null;

  /**
   * Set the message.
   * @param messageType message type
   * @param message message body
   * @param fade if provided, message fades away after this many milliseconds.
   */
  public setMessage(messageType: string, message: string, fade?: number) {
    this.message = {
      messageType,
      message,
      fade
    } as IMessage;
  }
}
